const ADMIN_EMAILS = new Set([
  'apexvectordev@gmail.com',
  'jason@email.com',
  'jason@paddiq.app',
  'ben@paddiq.app',
]);

const SUPER_ADMIN_EMAILS = new Set([
  'jason@email.com',
  'jason@paddiq.app',
  'ben@paddiq.app',
]);

export function canViewAdmin(user: { email: string } | null | undefined) {
  const email = user?.email.toLowerCase();
  return Boolean(email && ADMIN_EMAILS.has(email));
}

export function isSuperAdmin(user: { email: string } | null | undefined) {
  const email = user?.email.toLowerCase();
  return Boolean(email && SUPER_ADMIN_EMAILS.has(email));
}
